import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FiMapPin } from 'react-icons/fi';
import { motion } from 'framer-motion';
import backgroundImage from '../../../assets/images/cardbg-1.png';
import { fetchStates, selectStates } from '../../../redux/slices/catalogSlice';

const ConsultaExpressSection = () => {
  const dispatch = useDispatch();
  const states = useSelector(selectStates);

  const [formData, setFormData] = useState({
    description: '',
    estado: '',
  });

  // Fetch states on component mount
  useEffect(() => {
    dispatch(fetchStates(142)); // 142 is Mexico's country ID
  }, [dispatch]);

  const handleInputChange = field => e => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    console.log('Consulta Express:', formData);
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const headerTextVariants = {
    hidden: {
      opacity: 0,
      x: -50,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
        delay: 0.2,
      },
    },
  };

  return (
    <>
      {/* Header fuera del fondo */}
      <div>
        <div className="bg-custom-blue text-white p-4 flex items-center gap-4 overflow-hidden">
          <motion.h2
            className="text-3xl font-bold font-serif whitespace-nowrap ml-4 py-2"
            variants={headerTextVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            Consulta Express
          </motion.h2>
        </div>
      </div>

      <section
        className="relative py-10 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        {/* Overlay negro con baja opacidad */}
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        <div className="relative max-w-md mx-auto px-8">
          <motion.div
            className="mb-8"
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <p className="text-lg leading-relaxed text-gray-100 text-center">
              Conéctate en instantes con abogados especializados que resuelvan todas tus dudas
              legales, 100% en línea.
            </p>
          </motion.div>

          <motion.div
            variants={itemVariants}
            className="bg-white rounded-lg p-6 mb-12"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2, margin: '0px 0px -100px 0px' }}
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              <motion.div variants={itemVariants}>
                <div className="relative">
                  <div className="absolute left-5 top-6 text-blue-500">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  </div>
                  <textarea
                    value={formData.description}
                    onChange={handleInputChange('description')}
                    maxLength={500}
                    rows="4"
                    placeholder="Describe tu situación legal..."
                    className="w-full pl-14 pr-5 py-5 bg-white border-0 rounded-xl focus:outline-none text-gray-800 text-base placeholder-gray-400 resize-none shadow-sm hover:shadow-md transition-all duration-200"
                  />
                </div>
                <div className="flex justify-between items-center mt-2 px-2">
                  <span className="text-xs text-gray-400">Máximo 500 caracteres</span>
                  <span
                    className={`text-xs font-medium ${
                      formData.description.length > 450
                        ? formData.description.length >= 500
                          ? 'text-red-500'
                          : 'text-orange-500'
                        : 'text-gray-400'
                    }`}
                  >
                    {formData.description.length}/500
                  </span>
                </div>
              </motion.div>

              <motion.div variants={itemVariants}>
                <div className="relative">
                  <div className="absolute left-5 top-1/2 transform -translate-y-1/2 text-blue-500">
                    <FiMapPin className="w-5 h-5" />
                  </div>
                  <select
                    value={formData.estado}
                    onChange={handleInputChange('estado')}
                    className="w-full pl-14 pr-12 py-5 bg-white border-0 rounded-xl focus:outline-none text-gray-800 text-base appearance-none cursor-pointer shadow-sm hover:shadow-md transition-all duration-200"
                  >
                    <option value="">Estado</option>
                    {states.loading ? (
                      <option disabled>Cargando estados...</option>
                    ) : (
                      states.data.map(estado => (
                        <option key={estado.id} value={estado.name}>
                          {estado.name}
                        </option>
                      ))
                    )}
                  </select>
                  <div className="absolute right-5 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="pt-4">
                <button
                  type="submit"
                  className="w-3/4 bg-blue-600 text-white py-3 rounded-full font-medium text-base hover:bg-blue-700 transition-colors duration-200 focus:outline-none shadow-sm hover:shadow-lg items-center flex justify-center mx-auto"
                >
                  Registrar
                </button>
              </motion.div>
            </form>
          </motion.div>

          {/* ¿Por qué elegir Consulta Express? Section */}
          <motion.div
            variants={itemVariants}
            className="space-y-6 py-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <motion.h4 className="text-lg font-bold text-gray-200" variants={itemVariants}>
              ¿Por qué elegir Consulta Express?
            </motion.h4>

            <div className="space-y-6">
              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
                className="transition-transform duration-200"
              >
                <h5 className="font-bold text-gray-200 mb-2">Respuesta Inmediata</h5>
                <p className="text-sm text-gray-100 leading-relaxed">
                  Conecta con abogados especializados en tiempo real, sin esperas ni citas previas.
                </p>
              </motion.div>

              <motion.hr
                className="border-gray-300"
                variants={itemVariants}
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              />

              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
                className="transition-transform duration-200"
              >
                <h5 className="font-bold text-gray-200 mb-2">100% En Línea</h5>
                <p className="text-sm text-gray-100 leading-relaxed">
                  Consulta desde cualquier lugar, a través de videollamada.
                </p>
              </motion.div>

              <motion.hr
                className="border-gray-300"
                variants={itemVariants}
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              />

              <motion.div
                variants={itemVariants}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
                className="transition-transform duration-200"
              >
                <h5 className="font-bold text-gray-200 mb-2">Especialistas Verificados</h5>
                <p className="text-sm text-gray-100 leading-relaxed">
                  Todos nuestros abogados están certificados y especializados en sus áreas de
                  práctica.
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ConsultaExpressSection;
